import { merge } from 'lodash';
import { currentUser } from '../redux/actionCreators/async/auth';
import { updateUser, updateApplicant } from './../redux/actionCreators/sync';
import { updateProfile } from './../redux/actionCreators/sync/contacts';
import { updateCompany } from './../redux/actionCreators/sync/companies';

export default function refreshCurrentUser(store) {
  return new Promise((resolve, reject) => {
    store.dispatch(currentUser({
      success(userItems) {

        store.dispatch(updateUser(merge({loggedIn: true}, userItems[0])));

        if (~userItems[0].roles.indexOf('Client')) {
            store.dispatch(updateProfile(userItems[1].profile));
            store.dispatch(updateCompany({company: userItems[1].company}));
        } else if(~userItems[0].roles.indexOf('Applicant')) {
            store.dispatch(updateProfile(userItems[1]));
            store.dispatch(updateApplicant({ profile: userItems[1] }));
        }else {
            store.dispatch(updateProfile(userItems[1]));
        }

        return resolve();
      },
      error(err) {
        reject(err);
      }
    }));
  });
}

export function isUserAuthenticated(store) {
  return new Promise((resolve, reject) => {
    const state = store.getState();
    if (state.user && state.user.loggedIn) {
      return resolve();
    }

    return reject();
  });
}

export function hasRoles(store, roles) {
  return new Promise((resolve, reject) => {
    const state = store.getState();
    if (state.user && state.user.roles) {
      if (state.user.roles.some(role => roles.includes(role))) {
        resolve();
      }
    }

    reject();
  });
}



// WEBPACK FOOTER //
// ./shared/utils/refreshCurrentUser.js